/**
 * Bookmarks utility using localStorage.
 * No account needed — saved locally in the browser.
 */

const STORAGE_KEY = "ofalycee_bookmarks";

export function getBookmarks() {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function isBookmarked(slug) {
  return getBookmarks().some((b) => b.slug === slug);
}

export function addBookmark(article) {
  const bookmarks = getBookmarks();
  if (bookmarks.some((b) => b.slug === article.slug)) return bookmarks;
  const entry = {
    slug: article.slug,
    title: article.title,
    excerpt: article.excerpt || "",
    featured_image: article.featured_image || "",
    category: article.category_details?.[0]?.name || "",
    saved_at: new Date().toISOString(),
  };
  const updated = [entry, ...bookmarks];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return updated;
}

export function removeBookmark(slug) {
  const updated = getBookmarks().filter((b) => b.slug !== slug);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return updated;
}

export function toggleBookmark(article) {
  if (isBookmarked(article.slug)) {
    return { bookmarks: removeBookmark(article.slug), added: false };
  }
  return { bookmarks: addBookmark(article), added: true };
}
